import {useEffect} from 'react'

import {useShopperContextsMutation} from '@salesforce/commerce-sdk-react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {useUsid} from '@salesforce/commerce-sdk-react'

import {useBasketRecalculate} from '/overrides/app/hooks/use-basket-recalculate'

export const useSourceCodeValidate = (sourceCode) => {
    const {app: appConfig} = getConfig()
    const {featureFlags} = appConfig
    const {usid} = useUsid()
    const recalculateBasket = useBasketRecalculate()
    const createShopperContext = useShopperContextsMutation('createShopperContext')

    useEffect(() => {
        const validateSourceCodePromotion = async () => {
            if (featureFlags?.enableSourceCodeValidation && sourceCode) {
                try {
                    await createShopperContext.mutateAsync({
                        parameters: {usid},
                        body: {sourceCode}
                    })

                    await recalculateBasket.mutateAsync()
                } catch {
                    // pass
                }
            }
        }
        validateSourceCodePromotion()
    }, [sourceCode, usid])
}
